"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMFEAttributes = exports.addMFEContextToOptions = exports.pushMeasurement = exports.pushLog = exports.pushEvent = exports.pushError = void 0;
function isPrimitive(value) {
    return value === null || (typeof value !== "object" && typeof value !== "function");
}
// This function is used to process the context object before sending it to Faro. Faro only accepts string values for context.
function processContext(context) {
    const processedContext = Object.assign({}, context);
    Object.entries(processedContext).forEach(([key, value]) => {
        if (isPrimitive(value)) {
            processedContext[key] = String(value);
        }
        else {
            const error = new Error(`Invalid context parameter: "${key}". Context only supports primitive values.`);
            // eslint-disable-next-line no-console
            console.warn(error.message);
            throw error;
        }
    });
    return processedContext;
}
function formatMFEDetails(mfeDetails) {
    return {
        mfeName: mfeDetails.name || "",
        mfeVersion: mfeDetails.version || "",
        mfeBuild: mfeDetails.build || "",
        mfeModuleName: mfeDetails.moduleName || "",
        mfeDeliveryTags: new URLSearchParams(mfeDetails.deliveryTags).toString() || "",
    };
}
function addMFEContextToOptions(options, mfeDetails) {
    if (!mfeDetails || !Object.keys(mfeDetails).length) {
        if (options === null || options === void 0 ? void 0 : options.context) {
            options.context = processContext(options === null || options === void 0 ? void 0 : options.context);
        }
        return options;
    }
    return Object.assign(Object.assign({}, (options || {})), { context: processContext(Object.assign(Object.assign({}, ((options === null || options === void 0 ? void 0 : options.context) || {})), formatMFEDetails(mfeDetails))) });
}
exports.addMFEContextToOptions = addMFEContextToOptions;
function addMFEAttributes(attributes, mfeDetails) {
    if (!mfeDetails || !Object.keys(mfeDetails).length) {
        return processContext(attributes);
    }
    return processContext(Object.assign(Object.assign({}, (attributes || {})), formatMFEDetails(mfeDetails)));
}
exports.addMFEAttributes = addMFEAttributes;
const pushError = (value, options, mfeDetails) => {
    var _a;
    let optionsWithMFEInfo;
    try {
        optionsWithMFEInfo = addMFEContextToOptions(options, mfeDetails);
    }
    catch (_b) {
        return;
    }
    if (!((_a = window.puiFaro) === null || _a === void 0 ? void 0 : _a.api)) {
        return;
    }
    window.puiFaro.api.pushError(value, optionsWithMFEInfo);
};
exports.pushError = pushError;
const pushEvent = (name, attributes, domain, options, mfeDetails) => {
    var _a;
    let attributesWithMFEInfo;
    try {
        attributesWithMFEInfo = addMFEAttributes(attributes, mfeDetails);
    }
    catch (_b) {
        return;
    }
    if (!((_a = window.puiFaro) === null || _a === void 0 ? void 0 : _a.api)) {
        return;
    }
    window.puiFaro.api.pushEvent(name, attributesWithMFEInfo, domain, options);
};
exports.pushEvent = pushEvent;
const pushLog = (args, options, mfeDetails) => {
    var _a;
    let optionsWithMFEInfo;
    try {
        optionsWithMFEInfo = addMFEContextToOptions(options, mfeDetails);
    }
    catch (_b) {
        return;
    }
    if (!((_a = window.puiFaro) === null || _a === void 0 ? void 0 : _a.api)) {
        return;
    }
    window.puiFaro.api.pushLog(args, optionsWithMFEInfo);
};
exports.pushLog = pushLog;
const pushMeasurement = (payload, options, mfeDetails) => {
    var _a;
    let optionsWithMFEInfo;
    try {
        optionsWithMFEInfo = addMFEContextToOptions(options, mfeDetails);
    }
    catch (_b) {
        return;
    }
    if (!((_a = window.puiFaro) === null || _a === void 0 ? void 0 : _a.api)) {
        return;
    }
    window.puiFaro.api.pushMeasurement(payload, optionsWithMFEInfo);
};
exports.pushMeasurement = pushMeasurement;
//# sourceMappingURL=push.js.map